import { render, staticRenderFns } from "./credito.vue?vue&type=template&id=4db7f6d6"
import script from "./credito.ts?vue&type=script&lang=js&external"
export * from "./credito.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db7f6d6')) {
      api.createRecord('4db7f6d6', component.options)
    } else {
      api.reload('4db7f6d6', component.options)
    }
    module.hot.accept("./credito.vue?vue&type=template&id=4db7f6d6", function () {
      api.rerender('4db7f6d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/cliente/credito.vue"
export default component.exports